export default "__VITE_ASSET__CQLzkzNv__"